import type { TOC } from '@ember/component/template-only';

interface TooltipHeaderSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const PrismTooltipHeader = <template>
  <div class="prism-tooltip-header" ...attributes>
    <div class="prism-tooltip-header__container">
      <p class="text-300--regular">
        {{yield}}
      </p>
    </div>
  </div>
</template> satisfies TOC<TooltipHeaderSignature>;

export default PrismTooltipHeader;
